import React, { useEffect, useState } from 'react'
import { contactAction } from '../store/actions/contactActions';
import { useDispatch, useSelector } from 'react-redux';
import { Toaster, toast } from 'react-hot-toast';
import { REMOVE_MESSAGE } from '../store/Types/contactTypes';
import { CLOUDINARY_URL } from '../services/helper';

const Contact = () => {
    
    const [state, setState] = useState("");
    const [currentAttachment, setCurrentAttachment] = useState("Add Attachment");
    const dispatch = useDispatch();
    const { msg } = useSelector(state => state.contactReducer);
    
    useEffect(() => {
        if(msg)
        {
            toast.success(msg);
            dispatch({ type : REMOVE_MESSAGE });
        }
    }, [msg]);
    
  // Some animation affects javascript are here.
  useEffect(() => {
    
    const inputs = document.querySelectorAll(".contact-input");
    
    inputs.forEach((input) => {
        
            input.addEventListener("focus", () => {
                input.parentNode.classList.add("focus");
                input.parentNode.classList.add("not-empty");
            });
            
            input.addEventListener("blur", () => {
                if(input.value == "")
                {
                    input.parentNode.classList.remove("not-empty");
                }
                input.parentNode.classList.remove("focus");
            });
        });
    }, [state]);

    const handleInputs = (e) => {
        // Update the state
        setState({
            ...state,
            [e.target.name] : e.target.value
        });
        
    }
    
    const handleFiles = (e) => {
        setCurrentAttachment(e.target.files[0].name);
        setState({
            ...state,
            [e.target.name] : e.target.files[0]
        });
    }
    
    const postMsg = (e) => {
        e.preventDefault();
        console.log("Clicked !!");
        const { firstName, lastName, email, message, attachment } = state;
        const formData = new FormData();
        formData.append("firstName", firstName);
        formData.append("lastName", lastName);
        formData.append("email", email);
        formData.append("message", message);
        formData.append("attachment", attachment);
        setState("");
        dispatch(contactAction(formData));
    }
    
  return (
    <main>
        <section className="contact-section">
            <div className="contact-container">
            <Toaster
                position='top-center'
                reverseOrder = "false"
                toastOptions={{
                style: {
                    fontSize : "1.25rem",
                    fontWeight : "700",
                    marginTop : "110px"
                },
                }}
            />
                <div className="left">
                    <div className="form-wrapper">
                        <div className="contact-heading">
                            <h1>Let's work together<span>.</span></h1>
                            <p>Or reach us via : <span>chaitanyacp039@gmail.com</span></p>
                        </div>
                        <form action="#" className='contact-form' onSubmit={postMsg}>
                            <div className="input-wrapper">
                                <input onChange={handleInputs} value={state.firstName} className='contact-input' required autoComplete='off' name='firstName' id='firstName' type="text" />
                                <label htmlFor="firstName">First Name</label>
                                <i class="fa fa-address-card"></i>
                            </div>
                            <div className="input-wrapper">
                                <input onChange={handleInputs} value={state.lastName} className='contact-input' required autoComplete='off' name='lastName' id='lastName' type="text" />
                                <label htmlFor="firstName">Last Name</label>
                                <i class="fa fa-address-card"></i>
                            </div>
                            <div className="input-wrapper w-100">
                                <input onChange={handleInputs} value={state.email} className='contact-input' required autoComplete='off' name='email' id='email' type="email" />
                                <label htmlFor="firstName">Email</label>
                                <i class="fa fa-envelope"></i>
                            </div>
                            <div className="input-wrapper textarea w-100">
                                <textarea onChange={handleInputs} value={state.message} name="message" className='contact-input' autoComplete='off' required id="message">
                                </textarea>
                                <label htmlFor="message">Message</label>
                                <i class="fa fa-inbox"></i> 
                            </div>
                            <div className="contact-buttons w-100">
                                <button className="contact-btn upload">
                                    <span>
                                        <i class="fa fa-paperclip me-2"></i> {currentAttachment}
                                    </span>
                                    <input type="file" name='attachment' onChange={handleFiles} />
                                </button>
                                <input type="submit" value={"Send Message"} className='contact-btn' />
                            </div>
                        </form>
                    </div>
                </div>
                <div className="right">
                    <img src={CLOUDINARY_URL +  "/contact-png.png"} alt="" />
                </div>
            </div>
        </section>
    </main>
  )
}

export default Contact